import { createSelector, createSlice } from "@reduxjs/toolkit";

const commonDropDownSlice = createSlice({
    name: 'dropdown',
    initialState: {
        gettingDropdown: false,
        countryData: [],
        addressLoader: false,
        address: [],
        finalAddress: [],
        businessDescription: [],
        businessType: [],
        aquirer: [],
        terminalType: [],
        terminalModel: []
    },
    reducers: {
        fetchDropdown: (state) => {
            state.gettingDropdown = true;
        },
        getCountrySuccess: (state, action) => {
            state.gettingDropdown = false;
            state.countryData = [...action.payload]
        },
        stopLoading: (state) => {
            state.gettingDropdown = false;
            state.addressLoader = false
        },

        getAddress: (state) => {
            state.address = []
            state.addressLoader = true
        },
        storeAddress: (state, action) => {
            state.finalAddress = []
            state.address = action.payload
            state.addressLoader = false
        },
        getFinalAddress: (state) => {
            state.finalAddress = []
            state.addressLoader = true
        },
        storeFinalAddress: (state, action) => {
            state.address = []
            state.finalAddress = action.payload
            state.addressLoader = false
        },
        clearAddresses: (state) => {
            state.address = []
            state.finalAddress = []
        },


        createBusinessDescription: (state) => { },
        createdBusinessDescription: (state, action) => {
            state.businessDescription = [...state.businessDescription, action.payload]
        },
        getBusinessDescription: (state) => { },
        storeBusinessDescription: (state, action) => {
            state.businessDescription = action.payload
        },

        createBusinessType: (state) => { },
        createdBusinessType: (state, action) => {
            state.businessType = [...state.businessType, action.payload]
        },
        getBusinessType: (state) => { },
        storeBusinessType: (state, action) => {
            state.businessType = action.payload
        },


        createAquirer: (state) => { },
        createdAquirer: (state, action) => {
            state.aquirer = [action.payload, ...state.aquirer];
        },
        listAquirer: (state) => { },
        storeAquirer: (state, action) => {
            state.aquirer = action.payload;
        },


        createTerminalType: (state) => { },
        createdTerminalType: (state, action) => {
            state.terminalType = [action.payload, ...state.terminalType]
        },
        listTerminalType: (state) => { },
        storeTerminalType: (state, action) => {
            state.terminalType = action.payload
        },

        createTerminalModel: (state) => { },
        createdTerminalModel: (state, action) => {
            state.terminalModel = [action.payload, ...state.terminalModel]
        },
        listTerminalModel: (state) => { },
        storeTerminalModel: (state, action) => {
            state.terminalModel = action.payload
        },


        clearAllData: (state, action) => {
            if (action?.payload === 'all') {
                state.gettingDropdown = false
                state.addressLoader = false
                state.address = []
                state.finalAddress = []
                state.businessDescription = []
                state.businessType = []
                state.aquirer = []
                state.terminalType = []
                state.terminalModel = []
                state.countryData = []
            } else {
                state.gettingDropdown = false
                state.addressLoader = false
                state.address = []
                state.finalAddress = []
                state.businessDescription = []
                state.businessType = []
                state.aquirer = []
                state.terminalType = []
                state.terminalModel = []
            }
        },
    }
});

export const {
    clearAllData,
    fetchDropdown,
    getCountrySuccess,

    getAddress,
    storeAddress,
    getFinalAddress,
    storeFinalAddress,
    clearAddresses,

    stopLoading,

    getBusinessType,
    storeBusinessType,
    createBusinessType,
    createdBusinessType,

    getBusinessDescription,
    storeBusinessDescription,
    createBusinessDescription,
    createdBusinessDescription,

    createAquirer,
    createdAquirer,
    storeAquirer,
    listAquirer,

    createTerminalType,
    createdTerminalType,
    storeTerminalType,
    listTerminalType,

    createTerminalModel,
    createdTerminalModel,
    storeTerminalModel,
    listTerminalModel

} = commonDropDownSlice.actions;


export const dropdownSelector = createSelector(
    state => state,
    common => common.common
);

export default commonDropDownSlice.reducer;
